import React from 'react';
import { classNames, layoutClassNames, LayoutClassNameProps } from './classNames';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
  circle?: boolean;
  fullHeight?: boolean;
  rounded?: boolean;
  cardImageTop?: boolean;
  text?: boolean;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  circle = false,
  fullHeight = false,
  rounded = false,
  cardImageTop = false,
  text = true,
  className,
  style,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <div
    className={classNames(
      text ? 'skeleton-text' : undefined,
      circle ? 'rounded-circle' : undefined,
      fullHeight ? 'h-100' : undefined,
      !circle && rounded ? 'rounded' : undefined,
      cardImageTop ? 'card-img-top' : undefined,
      'bg-light-subtle',
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    style={{
      ...(width !== undefined ? { width } : {}),
      ...(height !== undefined ? { height } : {}),
      ...style,
    }}
    {...props}
  />
);

export default Skeleton;
